import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PsCoordinacionProyectoService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getAll(idps: number) {
    return this._http.get(this.myAppUrl + 'api/PS_CoordinacionProyecto/GetAll/' + idps);
  }

  getById(id: number) {
    return this._http.get(this.myAppUrl + 'api/PS_CoordinacionProyecto/' + id);
  }

  post(psCoordinacionProyecto: any) {
    return this._http.post(this.myAppUrl + 'api/PS_CoordinacionProyecto/', psCoordinacionProyecto);
  }

  put(id: number, psCoordinacionProyecto: any): Observable<any> {
    return this._http.put(this.myAppUrl + 'api/PS_CoordinacionProyecto/' + id, psCoordinacionProyecto);
  }

  delete(id: number): Observable<any> {
    return this._http.delete(this.myAppUrl + 'api/PS_CoordinacionProyecto/' + id);
  }

}
